import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <span className="text-2xl font-heading text-primary-500">
            羞羞歪歪漫画
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link
            to="/"
            className={`text-sm whitespace-nowrap cursor-pointer transition-colors ${
              location.pathname === "/"
                ? "text-primary-500 font-medium"
                : "text-foreground-700 hover:text-primary-500"
            }`}
          >
            首页
          </Link>
          {categories.slice(0, 5).map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`text-sm whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === `/category/${cat.slug}`
                  ? "text-primary-500 font-medium"
                  : "text-foreground-700 hover:text-primary-500"
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`text-sm whitespace-nowrap cursor-pointer transition-colors ${
              location.pathname === "/about"
                ? "text-primary-500 font-medium"
                : "text-foreground-700 hover:text-primary-500"
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700"
          aria-label="切换菜单"
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link
              to="/"
              className={`text-sm py-2 px-3 rounded-lg cursor-pointer transition-colors ${
                location.pathname === "/"
                  ? "bg-primary-100 text-primary-700 font-medium"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`text-sm py-2 px-3 rounded-lg cursor-pointer transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? "bg-primary-100 text-primary-700 font-medium"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm py-2 px-3 rounded-lg cursor-pointer transition-colors ${
                location.pathname === "/about"
                  ? "bg-primary-100 text-primary-700 font-medium"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}